import Chip from '@mui/material/Chip';
import { mapRole } from '@service/roleService'

const RoleChip = ({roleApiName, t }) => {
  const mappedRole = mapRole(roleApiName)
  if (!mappedRole) return null;

  const text = `L${mappedRole.level} | ${t(mappedRole.translationKey)}`;

  return (
    <Chip
      label={text}
      size="small"
      variant="outlined"
      onClick={()=>{}}
      sx={{
        backgroundColor: mappedRole.color,
        "& .MuiChip-label": {
          color: "#000 !important",
        },
      }}
    />
  );
};

export default RoleChip;